import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServerResponse } from 'src/app/models/serverResponse';
import { MasterDataTypes } from 'src/app/models/SystemEnums';
import { Router } from '@angular/router';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

const fileHttpOptions = {
  headers: new HttpHeaders({
    'file-upload': 'true',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class ServerService {
  //private apiUrl = 'http://localhost:5051';
  private apiUrl = 'https://knomi.co.za';
  
  constructor(private http: HttpClient, private router: Router) { }

  onLogin(username: string, password: string) {
    var data = { username: username, password: password };

    httpOptions.headers = httpOptions.headers.append('nospinner', 'true');
 
    return this.http.post<ServerResponse>(
      this.apiUrl + '/userLogin/LoginBackOffice',
      data,
      httpOptions
    );
  }

  onVerifyUserToken() {
    // let httpParams = new HttpParams()
    // .set('afsId', afsId);

    return this.http.get<ServerResponse>(
      this.apiUrl + '/userLogin/VerifyToken'
    );
  }

  onSaveMasterDataItem(
    name: string,
    displayText: string,
    masterDataItemType: MasterDataTypes,
    id: number = 0
  ) {
    var data = {
      name: name,
      displayText: displayText,
      masterDataType: masterDataItemType,
      id: id,
    };

    httpOptions.headers = httpOptions.headers.append('nospinner', 'true');

    return this.http.post<ServerResponse>(
      this.apiUrl + '/masterData/SaveMasterDataItem',
      data,
      httpOptions
    );
  }

  onGetMaterDataItems(masterDataType = 0) {
    let httpParams = new HttpParams().set('masterDataType', masterDataType);

    return this.http.get<ServerResponse>(
      this.apiUrl + '/masterData/GetMasterDataItems',
      { params: httpParams }
    );
  }

  onGetAllAppUsers(userId: number = 0) {

    if (userId > 0) {
      return this.http.get<ServerResponse>(this.apiUrl + '/BackOffice/GetAllAppUsers?userId=' + userId);
    }
    else {
      return this.http.get<ServerResponse>(this.apiUrl + '/BackOffice/GetAllAppUsers');
    }
  }

  onGetConnectionDashboard() {
    return this.http.get<ServerResponse>(
      this.apiUrl + '/BackOffice/GetConnectionDashboard'
    );
  }

  onGetUserAgeDashboard() {
    return this.http.get<ServerResponse>(
      this.apiUrl + '/BackOffice/GetUserAgeDashboard'
    );
  }

  onGetUserGenderDashboard() {
    return this.http.get<ServerResponse>(
      this.apiUrl + '/BackOffice/GetUserGenderDashboard'
    );
  }

  onGetUserLastSeenDashboard() {
    return this.http.get<ServerResponse>(
      this.apiUrl + '/BackOffice/GetUserLastSeenDashboard'
    );
  }

  onGetCategoryCountDashboard() {
    return this.http.get<ServerResponse>(
      this.apiUrl + '/BackOffice/GetCategoryCountDashboard'
    );
  }

  onGetPostedQuestionAndResponseDashboard() {
    return this.http.get<ServerResponse>(
      this.apiUrl + '/BackOffice/GetPostedQuestionAndResponseDashboard'
    );
  }

  onGetActivitiesByDayOfWeek() {
    return this.http.get<ServerResponse>(
      this.apiUrl + '/BackOffice/GetActivitiesByDayOfWeek'
    );
  }

  onGetOpenConnections(
    connectionStatus: number | null = 2,
    createdFromTs: string | null = null,
    createdToTs: string | null = null,
    page: number = 1,
    pageSize: number = 500
  ) {
    let params = new HttpParams()
      .set('page', page)
      .set('pageSize', pageSize);

    if (connectionStatus !== null && connectionStatus !== undefined) {
      params = params.set('connectionStatus', connectionStatus);
    }

    if (createdFromTs) {
      params = params.set('createdFromTs', createdFromTs);
    }

    if (createdToTs) {
      params = params.set('createdToTs', createdToTs);
    }

    return this.http.get<ServerResponse>(
      this.apiUrl + '/BackOffice/GetOpenConnections',
      { params }
    );
  }

  ProcessProfilePicUrl(profilePicture: string, fullImage: boolean = false, useDefaultErrorUserPicture: boolean = true) {
    if (profilePicture == null && useDefaultErrorUserPicture === true) return 'assets/images/static/user.png';

    if (profilePicture == null) {
      return 'assets/images/static/error.png';
    }

    const normalized = profilePicture.trim();

    // Keep absolute or protocol-relative URLs as-is (e.g. Cloudinary URLs).
    if (
      normalized.startsWith('http://') ||
      normalized.startsWith('https://') ||
      normalized.startsWith('//')
    ) {
      return normalized;
    }

    if (normalized.indexOf(this.getProfilePictureUrl(fullImage)) > -1)
      return profilePicture;

    return this.getProfilePictureUrl(fullImage) + normalized;
  }

  getProfilePictureUrl(fullImage: boolean = false): string {
    if (fullImage === true) {
      return this.apiUrl + '/Content/Images/ProfilePictures/';
    } else {
      return this.apiUrl + '/Content/Images/ProfilePicturesSmall/';
    }
  }

  onVerifyProfile(
    confirmVerificationPhoto: string,
    userId: number
  ) {

    var data = {
      confirmVerificationPhoto: confirmVerificationPhoto,
      userId: userId
    };

    //httpOptions.headers = httpOptions.headers.append('nospinner', 'true');

    return this.http.post<ServerResponse>(
      this.apiUrl + '/user/VerifyProfile',
      data,
      httpOptions
    );
  }


  onUnVerifyProfile(
    userId: number,
    reason: string
  ) {

    var data = {
      unverificationReason: reason,
      userId: userId
    };

    //httpOptions.headers = httpOptions.headers.append('nospinner', 'true');

    return this.http.post<ServerResponse>(
      this.apiUrl + '/user/UnverifyProfile',
      data,
      httpOptions
    );
  }
}
